export default __webpack_public_path__ + "static/media/logo_small_yellow.df0e1ad1.jpg";